module.exports = __webpack_public_path__ + "img/search.48457354.svg";